module.exports = __webpack_public_path__ + "img/invitations_1.3b6e3f0e.jpg";